import taskManagerApi from '@/features/shared/services/taskManagerApi';
const API_ROUTE = '/absence-types';
const extractErrorMessage = (error) => {
    if (error instanceof Error) {
        const serverError = error?.response?.data?.error;
        if (serverError) {
            const details = Array.isArray(serverError.details)
                ? serverError.details.join(' ')
                : serverError.details;
            return details ?? serverError.message ?? error.message;
        }
        return error.message;
    }
    return 'Une erreur inattendue est survenue.';
};
export const fetchAbsenceTypes = async (page = 1, filters = {}, all = false, limit = 10) => {
    try {
        const params = {
            ...(page ? { page } : {}),
            ...(limit ? { limit } : {}),
            ...(filters.code ? { code: filters.code } : {}),
            ...(filters.label ? { label: filters.label } : {}),
            ...(filters.active !== undefined && filters.active !== ''
                ? { active: filters.active }
                : {}),
            ...(all ? { all: true } : {}),
        };
        const response = await taskManagerApi.get(API_ROUTE, { params });
        return response.data.data;
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const createAbsenceType = async (payload) => {
    try {
        const response = await taskManagerApi.post(API_ROUTE, payload);
        return response.data.data;
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const updateAbsenceType = async ({ id, absenceType }) => {
    try {
        const response = await taskManagerApi.put(`${API_ROUTE}/${id}`, absenceType);
        return response.data.data;
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const deleteAbsenceType = async (id) => {
    try {
        await taskManagerApi.delete(`${API_ROUTE}/${id}`);
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
